/* eslint-disable react/display-name */
import React, { useState } from 'react'
import styled from 'styled-components'
import theme, { MyTheme } from 'Components/common/Theme'
import { getUomsMenuSelect, numberWithComma, roundNumber } from 'helpers/format'
import { Col, Dropdown, Image, Row, Space, Tag, Tooltip } from 'antd'
import { appConfig } from 'config'
import { TableListPage } from 'Components/common/Table'
import {
  CheckSquareOutlined,
  DeleteOutlined,
  InfoCircleFilled,
  PlusOutlined,
  PrinterOutlined,
  SelectOutlined,
} from '@ant-design/icons'
import { ImageFallback, QuotationStatus } from 'helpers/constanst'
import { selectPosBill } from 'Store/orders/selector'
import RootState from 'typings/RootState'
import { connect } from 'react-redux'
import { ActionButton, PrimaryButton, SecondaryButton } from 'Components/button'
import ProductsDrawer from './ProductsDrawer'
import { AppInput, AppSelect, AppTextArea, MenuPrints } from 'Components/form'
import ReactToPrint from 'react-to-print'
import { QuotationData, QuotationProduct } from 'Store/quotation/types'
import { cloneDeep } from 'lodash'
import { Theme } from 'Components/common'
import { OverstockTag } from 'Components/utilities'
import ProductMultiUoms from 'Pages/Product/components/ProductMultiUoms'
import ProductUomSystemInfo from 'Pages/Product/components/ProductUomSystemInfo'

type Props = {
  products: QuotationProduct[]
  onUpdateData?: (products: QuotationProduct[]) => void
  viewMode?: boolean
  quotationPdfRef?: any
  quotationLitePdfRef?: any
  quotation_no?: string
  detail?: QuotationData
  customerType: string
  isFranchise?: boolean
  hasOverstockPermission?: boolean
  hasNoneskuPermission?: boolean
  hasProductDiscount?: boolean
} & ReduxProps

const ProductsTable: React.FunctionComponent<Props> = props => {
  const [chooseProduct, setChooseProduct] = useState(false)
  const {
    products,
    onUpdateData = () => {},
    viewMode = false,
    quotationPdfRef,
    quotationLitePdfRef,
    quotation_no = '',
    detail,
    customerType,
    isFranchise = false,
    hasOverstockPermission = false,
    hasNoneskuPermission = false,
    hasProductDiscount = false,
  } = props

  const renderInfo = (val: any) => {
    return <RowTile>{val}</RowTile>
  }

  const onUpdateDataProduct = (val: string, name: string, updateIndex: number) => {
    const newProduct = products.map((item: any, index) => {
      if (index === updateIndex) {
        item[name] = val
      }
      return item
    })
    onUpdateData(newProduct)
  }

  const onUpdateQuantity = (product: QuotationProduct, val: string, updateIndex: number) => {
    const newProduct = products.map((item, index) => {
      if (index === updateIndex) {
        let quantity = parseInt(val)
        if (
          ((!hasOverstockPermission && product.sale_item_type !== 'none-sku') || isFranchise) &&
          quantity > product.current_stock
        ) {
          quantity = product.current_stock
        }
        item.quantity = quantity
      }
      return item
    })
    onUpdateData(newProduct)
  }

  const onUpdateUom = (product: QuotationProduct, val: string, updateIndex: number) => {
    const newProduct =
      products &&
      products.map((item, index) => {
        if (index === updateIndex) {
          const uomInfo = item.uoms?.find(uom => uom.id === parseInt(val)) as any
          item.product_uom_id = parseInt(val)
          item.product_uom = uomInfo?.uom_name || ''
          item.current_stock = uomInfo?.quantity_offline || 0
          item.unit = uomInfo?.uom_name || ''
          const priceBeforDiscount = parseFloat(uomInfo[customerType] || 0)
          item.price_before_discount = priceBeforDiscount
          item.price = priceBeforDiscount - (product.discount || 0)
          if (item.current_stock < product.quantity) {
            item.quantity = item.current_stock
          }
        }
        return item
      })
    onUpdateData(newProduct)
  }

  const onUpdatePrice = (product: QuotationProduct, val: string, updateIndex: number) => {
    const newProduct =
      products &&
      products.map((item, index) => {
        if (index === updateIndex) {
          const priceBeforDiscount = parseFloat(val)
          item.price_before_discount = priceBeforDiscount
          item.price = priceBeforDiscount - (product.discount || 0)
        }
        return item
      })
    onUpdateData(newProduct)
  }

  const onUpdateDiscount = (product: QuotationProduct, val: string, updateIndex: number) => {
    const newProduct =
      products &&
      products.map((item, index) => {
        if (index === updateIndex) {
          item.discount = parseFloat(val)
          item.price = product.price_before_discount - parseFloat(val)
        }
        return item
      })
    onUpdateData(newProduct)
  }

  const onAddNewProduct = () => {
    const currentProduct = cloneDeep(products)
    currentProduct.push({
      brand: '',
      code: '',
      current_stock: 0,
      picture: '',
      price_before_discount: 0,
      discount: 0,
      price: 0,
      product_id: 0,
      product_option_id: 0,
      quantity: 1,
      return_qty: 0,
      title: '',
      unit: '',
      barcode: '',
      bom: 0,
      sale_item_type: 'none-sku',
      id: 0,
      is_return: false,
      product_option_title: '',
    })
    onUpdateData(currentProduct)
  }

  const onRemoveProduct = (product: QuotationProduct, removeIndex: number) => {
    const newProduct = products && products.filter((item, index) => index != removeIndex)
    onUpdateData(newProduct)
  }

  const renderImage = (photo: any) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + photo} fallback={ImageFallback} />
  )

  // const renderProductName = (item: string, record: QuotationProduct) => {
  //   const isSameTitle = record.title == record.product_option_title
  //   return (
  //     <>
  //       <RowTile>{record.title}</RowTile>
  //       {!isSameTitle && <ProductDesc>{record.product_option_title}</ProductDesc>}
  //     </>
  //   )
  // }

  const renderActionButton = (text: string, record: any, index: number) => (
    <Space size="middle">
      <ActionButton
        text=""
        icon={<DeleteOutlined />}
        label="ลบ"
        action="view"
        onClick={() => onRemoveProduct(record, index)}
      />
    </Space>
  )

  const renderProductCode = (val: string, record: QuotationProduct, index: number) => {
    if (viewMode || record.sale_item_type !== 'none-sku') {
      return val
    } else {
      return (
        <AppTextArea
          name="code"
          label=""
          placeHolder="รหัส"
          isRequired={false}
          isError={false}
          value={record.code}
          onChange={(val, name) => onUpdateDataProduct(val, name, index)}
          key={`${record.product_id}-${record.product_option_id}}-${index}`}
          resProps={{ allowClear: false }}
          rows={1}
        />
      )
    }
  }

  const renderProductName = (val: string, record: QuotationProduct, index: number) => {
    if (viewMode || record.sale_item_type !== 'none-sku') {
      const isSameTitle = record.title == record.product_option_title
      return (
        <>
          <RowTile>{record.title}</RowTile>
          {!isSameTitle && <ProductDesc>{record.product_option_title}</ProductDesc>}
          <OverstockTag isOverstock={record.sale_item_type === 'overstock'} />
        </>
      )
    } else {
      return (
        <AppTextArea
          name="title"
          label=""
          placeHolder="ชื่อสินค้า"
          isRequired={true}
          errorMsg="ชื่อสินค้า"
          isError={record.title == ''}
          value={record.title}
          onChange={(val, name) => onUpdateDataProduct(val, name, index)}
          key={`${record.product_id}-${record.product_option_id}}-${index}`}
          resProps={{ allowClear: false }}
          rows={1}
        />
      )
    }
  }

  const renderProductUom = (uom: string, record: QuotationProduct, index: number) => {
    const uoms = record?.uoms || []
    if (viewMode) return <span></span>
    if (record.sale_item_type !== 'none-sku') {
      if (uoms.length <= 1) {
        return (
          <span>
            {' '}
            <ProductUomSystemInfo
              multiplier={record.multiplier}
              quantity={record.quantity}
              uom={record.product_uom}
              quantitySystem={record.quantity_system}
              uomSystem={record.product_uom_system}
              showQuantity={false}
            />
          </span>
        )
      } else {
        return (
          <Row gutter={[8, 8]} align="middle">
            <Col md={20}>
              <AppSelect
                name="product_uom_id"
                label=""
                errorMsg="หน่วย"
                isRequired={true}
                isError={!record?.product_uom_id}
                value={record.product_uom_id}
                onChange={val => onUpdateUom(record, val, index)}
                menu={getUomsMenuSelect(uoms)}
                key={`${record.product_id}-${record.product_option_id}`}
                allowClear={false}
              />
            </Col>
            <Col md={4}>
              <ProductMultiUoms
                uoms={uoms}
                label={' '}
                priceKey={customerType}
                priceTitle={'ราคา'}
                quantityType={'offline'}
                showMaster
              />
            </Col>
          </Row>
        )
      }
    } else {
      return (
        <AppTextArea
          name="unit"
          label=""
          errorMsg="หน่วย"
          isRequired={true}
          isError={record.unit == ''}
          value={record.unit}
          onChange={(val, name) => onUpdateDataProduct(val, name, index)}
          key={`${record.product_id}-${record.product_option_id}}-${index}`}
          resProps={{ allowClear: false }}
          rows={1}
          placeHolder="หน่วย"
        />
      )
    }
  }

  const renderProductBrand = (val: string, record: QuotationProduct, index: number) => {
    if (viewMode || record.sale_item_type !== 'none-sku') {
      return val
    } else {
      return (
        <AppTextArea
          name="brand"
          label=""
          isRequired={false}
          isError={false}
          value={record.brand}
          onChange={(val, name) => onUpdateDataProduct(val, name, index)}
          key={`${record.product_id}-${record.product_option_id}}-${index}`}
          resProps={{ allowClear: false }}
          rows={1}
          placeHolder="ยี่ห้อ"
        />
      )
    }
  }

  const renderProductUnit = (val: string, record: QuotationProduct, index: number) => {
    if (viewMode || record.sale_item_type !== 'none-sku') {
      return val
    } else {
      return (
        <AppTextArea
          name="unit"
          label=""
          errorMsg="หน่วย"
          isRequired={true}
          isError={record.unit == ''}
          value={record.unit}
          onChange={(val, name) => onUpdateDataProduct(val, name, index)}
          key={`${record.product_id}-${record.product_option_id}}-${index}`}
          resProps={{ allowClear: false }}
          rows={1}
          placeHolder="หน่วย"
        />
      )
    }
  }

  const renderQuantity = (item: string, record: QuotationProduct, index: number) => {
    if (viewMode) {
      return (
        <Space>
          {numberWithComma(record.quantity)}
          <ProductUomSystemInfo
            multiplier={record.multiplier}
            quantity={record.quantity}
            uom={record.product_uom}
            quantitySystem={record.quantity_system}
            uomSystem={record.product_uom_system}
            showQuantity={true}
          />
        </Space>
      )
    } else {
      return (
        <>
          <AppInput
            name="quantity"
            label=""
            type="number"
            errorMsg="จำนวน"
            isRequired={true}
            isError={isNaN(record.quantity) || record.quantity <= 0}
            value={record.quantity}
            onChange={val => onUpdateQuantity(record, val, index)}
            key={`${record.product_id}-${record.product_option_id}}-${index}`}
            resProps={{ suffix: record.unit }}
          />
          {hasOverstockPermission &&
            record?.sale_item_type !== 'none-sku' &&
            record?.current_stock < record.quantity && (
              <Tooltip
                placement="bottom"
                title="ขายสินค้านอกสต๊อก คือ จำนวนสต๊อกสินค้าที่ทางร้านต้องการขายมากกว่าจำนวนสต๊อกที่มีในปัจจุบัน โดยระบบจะไม่นำจำนวนไปตัดสต๊อกที่มีในปัจจุบันของร้าน"
              >
                <Warning>
                  <InfoCircleFilled color={theme.colors.primary} /> ขายสินค้านอกสต๊อก
                </Warning>
              </Tooltip>
            )}
        </>
      )
    }
  }

  const renderPrice = (item: string, record: QuotationProduct, index: number) => {
    if (viewMode) {
      return numberWithComma(record.price_before_discount, true)
    } else {
      return (
        <AppInput
          name="price_before_discount"
          label=""
          type="number"
          errorMsg="ราคา"
          isRequired={true}
          isError={isNaN(record.price_before_discount) || record.price_before_discount <= 0}
          value={roundNumber(record.price_before_discount)}
          onChange={val => onUpdatePrice(record, val, index)}
          key={`${record.product_id}-${record.product_option_id}}-${index}`}
        />
      )
    }
  }

  const renderDiscountPrice = (item: string, record: QuotationProduct, index: number) => {
    if (viewMode) {
      return numberWithComma(record.discount, true)
    } else {
      return (
        <AppInput
          name="discount"
          label=""
          type="number"
          errorMsg="ราคา"
          isRequired={true}
          isError={false}
          value={roundNumber(record.discount)}
          onChange={val => onUpdateDiscount(record, val, index)}
          key={`${record.product_id}-${record.product_option_id}}-${index}`}
        />
      )
    }
  }

  const renderTotalPrice = (item: string, record: QuotationProduct) => {
    return <TextRight>{numberWithComma((record.quantity || 0) * (record.price || 0), true)}</TextRight>
  }

  const renderStock = (quantity: number, record: QuotationProduct) => {
    console.log('record', record)
    const uomId = record?.product_uom_id || 0
    const stock = uomId ? record?.uoms?.find(item => item.id === uomId)?.quantity_offline || 0 : quantity
    if (viewMode) return
    return !stock || stock <= 10 ? (
      <div>{record?.sale_item_type === 'none-sku' ? '-' : <StockMin>{numberWithComma(stock)}</StockMin>}</div>
    ) : (
      numberWithComma(stock)
    )
  }

  const columns = [
    {
      title: <ColTile>#</ColTile>,
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return renderInfo(index + 1)
      },
      width: '30px',
    },
    {
      title: <ColTile>รูปภาพ</ColTile>,
      dataIndex: 'picture',
      key: 'picture',
      width: '70px',
      render: renderImage,
    },
    {
      title: <ColTile>รหัสสินค้า</ColTile>,
      dataIndex: 'code',
      key: 'code',
      width: '100px',
      render: renderProductCode,
    },
    {
      title: <ColTile>รายการ</ColTile>,
      dataIndex: 'title',
      key: 'title',
      render: renderProductName,
      width: '180px',
    },
    {
      title: <ColTile>ยี่ห้อ</ColTile>,
      dataIndex: 'brand',
      key: 'brand',
      width: '100px',
      render: renderProductBrand,
    },
    {
      title: viewMode ? '' : <ColTile>หน่วย</ColTile>,
      dataIndex: 'unit',
      key: 'unit',
      width: viewMode ? '0px' : '180px',
      render: renderProductUom,
    },
    {
      title: viewMode ? '' : <ColTile>สต๊อกคงเหลือ</ColTile>,
      dataIndex: 'current_stock',
      key: 'current_stock',
      width: viewMode ? '0px' : '100px',
      render: renderStock,
      align: 'center',
    },
    {
      title: <ColTile>จำนวน</ColTile>,
      dataIndex: 'quantity',
      key: 'quantity',
      width: '150px',
      render: renderQuantity,
    },
    {
      title: <ColTile>ราคา/หน่วย</ColTile>,
      dataIndex: 'price',
      key: 'price',
      width: '150px',
      render: renderPrice,
    },
    viewMode || hasProductDiscount
      ? {
          title: <ColTile>ส่วนลด/หน่วย</ColTile>,
          dataIndex: 'discount',
          key: 'discount',
          width: '150px',
          render: renderDiscountPrice,
        }
      : {
          title: '',
          dataIndex: 'discount',
          key: 'discount',
          width: '0px',
          render: () => null,
        },
    {
      title: (
        <ColTile>
          <TextRight>ราคารวม</TextRight>
        </ColTile>
      ),
      dataIndex: 'total_discount',
      key: 'total_discount',
      render: renderTotalPrice,
      width: '100px',
    },
    {
      title: '',
      key: 'action',
      width: '50px',
      render: !viewMode && renderActionButton,
    },
  ]

  const ChooseProductsDrawer = (
    <ProductsDrawer
      visible={chooseProduct}
      onCloseDrawer={() => setChooseProduct(false)}
      onSaveProduct={(products: QuotationProduct[]) => {
        onUpdateData(products)
        setChooseProduct(false)
      }}
      products={products}
      customerType={customerType}
    />
  )

  const renderHeader = () => {
    const status = detail?.status
    return (
      <Row justify="space-between" gutter={[32, 32]} align="middle">
        <Col>
          {viewMode ? (
            <BoxTitle>สรุปรายละเอียดใบเสนอราคา</BoxTitle>
          ) : (
            <BoxTitle>
              เลือกสินค้าสำหรับออกใบเสนอราคา (จำนวนสินค้าที่เลือก {products?.length || 0} รายการ)
            </BoxTitle>
          )}
        </Col>
        {(status === QuotationStatus.DRAFT ||
          status === QuotationStatus.SUCCESS ||
          status === QuotationStatus.PENDING) && (
          <Col>
            <Space>
              <Dropdown
                key="more"
                overlay={
                  <MenuPrints
                    nomalPrintRef={quotationPdfRef}
                    litePrintRef={quotationLitePdfRef}
                    title={`ใบเสนอราคา-${quotation_no}`}
                  />
                }
                trigger={['click', 'hover']}
              >
                <PrimaryButton
                  btnType="Approve"
                  text="ใบเสนอราคา"
                  icon={<PrinterOutlined />}
                  onClick={() => {}}
                  size="middle"
                />
              </Dropdown>
            </Space>
          </Col>
        )}
      </Row>
    )
  }

  return (
    <BoxWrapper>
      <Row gutter={[16, 8]}>
        <Col span={24}>
          {renderHeader()}
          <TableListPage
            rowKey="product_option_id"
            tableName="product-purchase"
            columns={columns}
            datas={products}
            size={'small'}
            // rowClassName={(record: QuotationProduct) =>
            //   viewMode && record.sale_item_type === 'overstock' ? 'overstock' : ''
            // }
          />
        </Col>
      </Row>
      <Row justify="space-between" gutter={[8, 8]}>
        <Col>
          <Space>
            {!viewMode && (
              <PrimaryButton
                btnType="Primary"
                text="เลือกสินค้า"
                onClick={() => setChooseProduct(true)}
                icon={<CheckSquareOutlined />}
                size="middle"
              />
            )}
            {!viewMode && hasNoneskuPermission && (
              <PrimaryButton
                btnType="Approve"
                text="เพิ่มสินค้า"
                onClick={onAddNewProduct}
                icon={<PlusOutlined />}
                size="middle"
              />
            )}
          </Space>
        </Col>
      </Row>
      {ChooseProductsDrawer}
    </BoxWrapper>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const StockMin = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 60px;
  height: 60px;
  object-fit: cover;
`

const ColTile = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const RowTile = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const ProductDesc = styled(RowTile)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const TextRight = styled.div`
  text-align: right;
`

const Warning = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  margin-top: -20px;
  cursor: pointer;
`

const mapStateToProps = (state: RootState) => {
  return {
    billData: selectPosBill(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ProductsTable)
